import ReactDOM from 'react-dom';

export const Portal: React.FC<any> = ({children}) => {

    const portalRoot = document.getElementById('portal-root');
    if (!portalRoot) return null

    return (
        <>
            { ReactDOM.createPortal(
                    <>
                        {children}
                    </>,
                    portalRoot
                )
            }
        </>
    )
}